<template>
  <transition name="fade" mode="out-in">
    <v-app>
      <navigation-drawer-component></navigation-drawer-component>
      <app-bar-component></app-bar-component>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <transition name="toast-slide">
        <div v-if="snackbar.active" :class="['app-toast', `app-toast--${snackbar.type || 'info'}`]">
          <div class="app-toast__accent"></div>
          <v-icon class="app-toast__icon" size="26">{{ toastIcon }}</v-icon>
          <span class="app-toast__message">{{ snackbar.message }}</span>
          <v-btn icon small class="app-toast__close" @click="closeToast">
            <v-icon size="18">mdi-close</v-icon>
          </v-btn>
        </div>
      </transition>
      <BaseDialogComponent></BaseDialogComponent>
    </v-app>
  </transition>
</template>
<style>
/* Estilos globales para tema oscuro */
.v-application {
  background-color: #121212 !important;
  color: #e0e0e0 !important;
}

.v-card__title,
.v-card__subtitle,
.v-card__text {
  color: #e0e0e0 !important;
}

.v-data-table {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
}

.v-data-table thead th {
  color: #e0e0e0 !important;
}

.v-data-table tbody tr {
  color: #e0e0e0 !important;
}

.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #2e2e2e !important;
}

.theme--dark.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: #e0e0e0 !important;
}

.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.v-list-item__title,
.v-list-item__subtitle {
  color: #e0e0e0 !important;
}

.theme--dark.v-sheet {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* Toast notification */
.app-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 360px;
  max-width: 600px;
  padding: 18px 20px 18px 0;
  border-radius: 16px;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5), 0 2px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.app-toast__accent {
  width: 5px;
  min-width: 5px;
  align-self: stretch;
  border-radius: 0 4px 4px 0;
  margin-right: 4px;
}

.app-toast__icon {
  flex-shrink: 0;
}

.app-toast__message {
  flex: 1;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.01em;
}

.app-toast__close {
  flex-shrink: 0;
  opacity: 0.7;
}
.app-toast__close:hover {
  opacity: 1;
}

/* Tipos */
.app-toast--success {
  background: linear-gradient(135deg, rgba(18, 42, 28, 0.96) 0%, rgba(10, 30, 20, 0.96) 100%);
  color: #5effa0;
}
.app-toast--success .app-toast__accent { background: #26de81; box-shadow: 0 0 12px #26de81; }
.app-toast--success .app-toast__icon { color: #26de81 !important; filter: drop-shadow(0 0 6px #26de81); }
.app-toast--success .app-toast__close .v-icon { color: #5effa0 !important; }

.app-toast--error {
  background: linear-gradient(135deg, rgba(42, 10, 14, 0.96) 0%, rgba(30, 6, 10, 0.96) 100%);
  color: #ffb3bc;
}
.app-toast--error .app-toast__accent { background: #fc5c65; box-shadow: 0 0 12px #fc5c65; }
.app-toast--error .app-toast__icon { color: #fc5c65 !important; filter: drop-shadow(0 0 6px #fc5c65); }
.app-toast--error .app-toast__close .v-icon { color: #ffb3bc !important; }

.app-toast--warning {
  background: linear-gradient(135deg, rgba(40, 30, 5, 0.96) 0%, rgba(28, 20, 2, 0.96) 100%);
  color: #ffe4a0;
}
.app-toast--warning .app-toast__accent { background: #fed330; box-shadow: 0 0 12px #fed330; }
.app-toast--warning .app-toast__icon { color: #fed330 !important; filter: drop-shadow(0 0 6px #fed330); }
.app-toast--warning .app-toast__close .v-icon { color: #ffe4a0 !important; }

.app-toast--info {
  background: linear-gradient(135deg, rgba(8, 20, 40, 0.96) 0%, rgba(4, 12, 28, 0.96) 100%);
  color: #a8d8ff;
}
.app-toast--info .app-toast__accent { background: #45aaf2; box-shadow: 0 0 12px #45aaf2; }
.app-toast--info .app-toast__icon { color: #45aaf2 !important; filter: drop-shadow(0 0 6px #45aaf2); }
.app-toast--info .app-toast__close .v-icon { color: #a8d8ff !important; }

/* Animación entrada/salida */
.toast-slide-enter-active {
  animation: toast-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
.toast-slide-leave-active {
  animation: toast-out 0.3s ease-in forwards;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-28px) scale(0.92);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

@keyframes toast-out {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-16px) scale(0.95);
  }
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AppBarComponent from './components/AppBarComponent.vue'
import LoaderComponent from './components/LoaderComponent'
import NavigationDrawerComponent from './components/NavigationDrawerComponent.vue'
import BaseDialogComponent from './components/BaseDialogComponent.vue'

export default {
  name: 'App',

  components: { LoaderComponent, NavigationDrawerComponent, AppBarComponent, BaseDialogComponent },

  async mounted() {
    // El tema oscuro está configurado globalmente en vuetify.js
    // Los colores de cada módulo se aplican mediante setThemeByModule() en main.js
    // cuando el usuario navega a un módulo específico
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
      snackbar: 'getSnackbar',
      token: 'getToken',
    }),

    toastIcon() {
      const icons = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information',
      }
      return icons[this.snackbar.type] || icons.info
    },
  },

  watch: {
    'snackbar.active'(val) {
      if (val) {
        clearTimeout(this._toastTimer)
        this._toastTimer = setTimeout(() => this.closeToast(), 4500)
      }
    },
  },

  methods: {
    ...mapMutations(['CLOSE_SNACKBAR']),

    closeToast() {
      this.CLOSE_SNACKBAR()
    },

    ...mapActions('capacitador', ['fetchCapacitadores']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('cursoProgramado', ['fetchCursosProgramados']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapActions('estatusCurso', ['fetchEstatusCurso']),
    ...mapActions('estatusCursoPersonal', ['fetchEstatusCursoPersonal']),

    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),
    ...mapActions('calibre', ['fetchCalibres']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('marcaArma', ['fetchMarcaArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('tipoEntregaArma', ['fetchTiposEntrega']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),

    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('principio', ['fetchPrincipios']),
    ...mapActions('reactivo', ['fetchReactivos']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('periodicidad', ['fetchPeriodicidad']),
    ...mapActions('resultado', ['fetchResultados']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('funcion', ['fetchFunciones']),
    ...mapActions('indicador', ['fetchIndicadores']),
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
    ...mapActions('actoRelevante', ['fetchActosRelevantes']),

    ...mapActions('tipoItem', ['fetchTiposItem']),

    ...mapActions('item', ['fetchItemsByType']),

    ...mapActions('preaspirante', ['fetchPreaspirantes']),

    ...mapActions('candidato', ['fetchCandidatos']),
    ...mapActions('categoria', ['fetchCategorias']),

    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),

    ...mapActions('estudio', ['fetchTipoEstudios']),

    ...mapActions('perfil', ['fetchPerfiles']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('estado', ['fetchEstados']),

    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),

    ...mapActions('preaspirante', ['fetchAspirantes']),

    ...mapActions('rama', ['fetchRamas']),
    ...mapActions('region', ['fetchRegiones']),
    ...mapMutations(['DISABLE_LOADER']),
  },
}
</script>
